/// <reference types="vite-plugin-svgr/client" />
import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Menu, MenuDropdown, UnstyledButton } from '@mantine/core'

import { isUserRole } from '@/types/userStore.types'

import type { SwitchRoleProps } from '@/layouts/AuthenticatedLayout/components/SwitchRole/SwitchRole.types'

import { useUserStore } from '@/store/user.store'

import type { role as Roles } from '@/__generated__/requests'

import { getUserDefaultPath } from '@/helpers/getUserDefaultPath.helper'
import { sanitizeEnum } from '@/helpers/sanitizeEnum.helper'

import SwitchIcon from '@/assets/icons/switchIcon.svg?react'

import classes from './SwitchRole.module.css'

export function SwitchRole({ user }: SwitchRoleProps) {
  const [opened, setOpened] = useState<boolean>(false)

  const navigate = useNavigate()

  const currentRole = useUserStore.use.currentRole()
  const rolesSwitch = user.roles?.filter(role => role !== currentRole)

  const setCurrentRole = useUserStore.use.setCurrentRole()

  const handleSwitchView = (role: Roles | null) => {
    setCurrentRole(role)
    navigate(getUserDefaultPath(user, role))
  }

  return (
    <Menu onChange={setOpened} opened={opened} position="bottom-start">
      <Menu.Target>
        <UnstyledButton
          className={`${classes.button} ${opened && classes.buttonActive}`}
        >
          <SwitchIcon />
        </UnstyledButton>
      </Menu.Target>
      <MenuDropdown>
        {rolesSwitch &&
          rolesSwitch.map(role => (
            <Menu.Item
              key={role}
              onClick={() => handleSwitchView(isUserRole(role) ? role : null)}
            >
              Switch to {sanitizeEnum(role)} view
            </Menu.Item>
          ))}
      </MenuDropdown>
    </Menu>
  )
}
